import {RecordForm} from '../forms/RecordForm';
import {useSubscription} from '../hooks/useSubscription';
import {Subscription} from '../types';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Card, Text, Button, Group, Badge, Stack } from '@mantine/core';
import { subscribeToProduct } from '../services/SubscriptionsService';
import { notifications } from '@mantine/notifications';

export const AddPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { selectedProduct, selectedPrice } = location.state || {};
    const [isSubscribing, setIsSubscribing] = useState(false);
    
    console.log('AddPage - location.state:', location.state);
    console.log('AddPage - selectedProduct:', selectedProduct);
    console.log('AddPage - selectedPrice:', selectedPrice);
    
    const {
        createRecord,
    } = useSubscription();
    
    const [record, setRecord] = useState<Partial<Subscription> | undefined>();

    const handleDirectSubscribe = async () => {
        if (!selectedPrice) return;
        
        setIsSubscribing(true);
        try {
            await subscribeToProduct('customer-123', selectedPrice.id);
            notifications.show({
                title: 'Success',
                message: 'Successfully subscribed to product',
                color: 'green'
            });
            navigate('/subscriptions');
        } catch (error) {
            notifications.show({
                title: 'Error', 
                message: 'Failed to subscribe to product',
                color: 'red'
            });
        } finally {
            setIsSubscribing(false);
        }
    };

    useEffect(() => {
        if (selectedProduct && selectedPrice) {
            const prefilledRecord = {
                ...record,
                items: {
                    items: [{
                        id: '',
                        priceId: selectedPrice.id,
                        price: {
                            product: selectedProduct,
                            amount: selectedPrice.amount,
                            billingPeriod: selectedPrice.billingPeriod
                        },
                        quantity: 1
                    }],
                    nextToken: ''
                }
            };
            setRecord(prefilledRecord);
        }
    }, [selectedProduct, selectedPrice, record, setRecord]);

    if (selectedProduct && selectedPrice) {
        return (
            <FormPageLayout
                title='Subscribe to Product'
                pageNavigation={<IndexPageNavigation/>}
            >
                <SimplePageContentWrapper>
                    <Card shadow="sm" padding="lg" radius="md" withBorder>
                        <Stack gap="md">
                            <Text fw={500} size="lg">Confirm Subscription</Text>
                            
                            <Group justify="space-between">
                                <Text fw={500}>{selectedProduct.name}</Text>
                                <Badge color="green">New Subscription</Badge>
                            </Group>
                            
                            {selectedProduct.shortDescription && (
                                <Text size="sm" c="dimmed">{selectedProduct.shortDescription}</Text>
                            )}
                            
                            <Card padding="sm" withBorder>
                                <Group justify="space-between">
                                    <Group>
                                        <Text fw={500}>${selectedPrice.amount}</Text>
                                        <Badge variant="light">{selectedPrice.billingPeriod}</Badge>
                                    </Group>
                                    <Text size="sm">Quantity: 1</Text>
                                </Group>
                            </Card>
                            
                            <Group justify="flex-end">
                                <Button 
                                    variant="light" 
                                    onClick={() => navigate('/subscriptions/products')}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    onClick={handleDirectSubscribe}
                                    loading={isSubscribing}
                                >
                                    Subscribe Now
                                </Button>
                            </Group>
                        </Stack>
                    </Card>
                </SimplePageContentWrapper>
            </FormPageLayout>
        );
    }

    return (
        <FormPageLayout
            title='Add Subscription'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={(record as Omit<Subscription, 'id'>) || {} as Omit<Subscription, 'id'>} handleSubmit={createRecord}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};


